/**
 * Mensagens e checagem de estoque antes de excluir insumo da empresa.
 */

export function formatQuantidadeEstoque(qtd) {
  const n = Number(qtd);
  if (!Number.isFinite(n)) return '0';
  return n.toLocaleString('pt-BR', { maximumFractionDigits: 4 });
}

export function mensagemBloqueioExclusaoPorEstoque({
  nome,
  quantidade_atual,
  unidade,
  quantidade_recebimentos,
  lotes_recebimentos,
}) {
  const qtd = formatQuantidadeEstoque(quantidade_atual);
  const un = unidade || 'kg';
  let detalhe = '';
  if (Number(quantidade_recebimentos) > 0) {
    detalhe =
      `\n(Inclui ${formatQuantidadeEstoque(quantidade_recebimentos)} ${un} em ` +
      `${lotes_recebimentos || 'vários'} recebimento(s) aceito(s). Zere na tela Estoque.)`;
  }
  return (
    `Não é possível excluir "${nome}".\n\n` +
    `Saldo disponível: ${qtd} ${un}${detalhe}\n\n` +
    `Este insumo só poderá ser excluído depois que todo o estoque for consumido ou zerado.`
  );
}

/** Extrai detalhes de erro retornado pelo deleteProduct (HttpsError failed-precondition). */
export function parseErroExclusaoInsumo(error) {
  const details = error?.details || error?.customData;
  if (details?.code === 'ESTOQUE_POSITIVO' || details?.quantidade_atual != null) {
    return mensagemBloqueioExclusaoPorEstoque({
      nome: details.produto_nome || 'Insumo',
      quantidade_atual: details.quantidade_atual,
      unidade: details.unidade,
      quantidade_recebimentos: details.quantidade_recebimentos,
      lotes_recebimentos: details.lotes_recebimentos,
    });
  }
  if (error?.code === 'functions/failed-precondition' && error?.message) {
    return error.message;
  }
  return error?.message || 'Erro ao excluir o item.';
}

export async function verificarEstoqueAntesExcluirInsumo({
  consultarSaldoFn,
  productId,
  empresaId,
  produto,
  pularSeServico = true,
}) {
  if (pularSeServico && produto?.tipo_insumo === 'servico') {
    return { podeExcluir: true };
  }

  const res = await consultarSaldoFn({
    produto_id: productId,
    materia_prima_id: productId,
    produto_nome: produto?.nome || '',
    empresa_id: empresaId,
  });

  const est = res?.data?.data || res?.data || {};
  const qtd = Number(est.quantidade_atual) || 0;
  const podeExcluirServidor = est.pode_excluir === true;

  if (podeExcluirServidor && qtd <= 1e-6) {
    return { podeExcluir: true };
  }

  if (qtd > 1e-6) {
    return {
      podeExcluir: false,
      quantidade_atual: qtd,
      unidade: est.unidade || produto?.unidade_medida || 'kg',
      nome: produto?.nome || est.materia_prima_nome || 'Insumo',
      quantidade_recebimentos: est.quantidade_recebimentos,
      lotes_recebimentos: est.lotes_recebimentos,
    };
  }

  if (est.pode_excluir === false) {
    return {
      podeExcluir: false,
      quantidade_atual: qtd,
      unidade: est.unidade || produto?.unidade_medida || 'kg',
      nome: produto?.nome || est.materia_prima_nome || 'Insumo',
      quantidade_recebimentos: est.quantidade_recebimentos,
      lotes_recebimentos: est.lotes_recebimentos,
    };
  }

  return { podeExcluir: true };
}
